import { render } from "./WorkImages.vue?vue&type=template&id=490e3760"
import script from "./WorkImages.vue?vue&type=script&lang=js"
export * from "./WorkImages.vue?vue&type=script&lang=js"

import "./WorkImages.vue?vue&type=style&index=0&id=490e3760&lang=css"

import exportComponent from "/Users/brian/Documents/web-projects/clients/andy/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__